import { render, staticRenderFns } from "./Grid.vue?vue&type=template&id=96968ec6&lang=pug"
import script from "./Grid.vue?vue&type=script&lang=ts"
export * from "./Grid.vue?vue&type=script&lang=ts"
import style0 from "./Grid.vue?vue&type=style&index=0&id=96968ec6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports